import forEach from 'lodash/forEach';

export const translations = {
    'fi-FI': {
        'Nästa': 'Seuraava',
        'Föregående': 'Edellinen',
        'Skicka': 'Lähetä',
        'Välj kontor': 'Valitse toimisto',
        'Hur många sökande': 'Kuinka monta hakijaa',
        'Förnamn': 'Etunimi',
        'Efternamn': 'Sukunimi',
        'Personnummer': 'Sosiaaliturvatunnus',
        'Adress': 'Osoite',
        'Postnummer': 'Postinumero',
        'Ort': 'Paikka',
        'Telefon': 'Puhelin',
        'Epost': 'Sähköposti',
        'Civilstånd': 'Siviilisääty',
        'Jag är Ålandsbankens kund': 'Olen Ålandsbankenin asiakas'
    }
};

export function translate(val, params = {}) {
    const locale = ALANDSBANKEN.language || 'sv-AX';
    const trans = translations[locale] || {};
    let string = trans[val] || val;

    forEach(params, (value, key) => {
        let regex = new RegExp('{' + key + '}');
        string = string.replace(regex, value);
    });

    return string;
}
